import { InjectionToken } from '@angular/core';

export type RunAfterLcpType = {
    runAfterLcp(fn: () => void): void;
};
export const RUN_AFTER_LCP_TOKEN = new InjectionToken<RunAfterLcpType>('lcp-token', {
    providedIn: 'root',
    factory: () => ({
        runAfterLcp(fn: () => void) {
            fn();
        },
    }),
});
